




































import Vue from "vue";
import { yandexMap, ymapMarker } from "vue-yandex-maps";

import { commonModule } from "@/plugins/store-accessors";

export default Vue.extend({
  name: "contacts-map",
  components: {
    yandexMap,
    ymapMarker,
  },
  props: {
    data: Object,
  },
  computed: {
    contacts() {
      return commonModule.getContacts;
    },
  },
});
